module.exports = __webpack_public_path__ + "static/media/Hammer 1.2f0cdeb4.svg";